import Btn from '../utils/btn';

const func = $target => {
    // remove freeform ajax enabled callbacks
    window.renderFormErrors = function(errors, form) {
        console.log(errors);
    };
    window.renderErrors = function(errors, form) {
        console.log(errors);
    };

    var $btn = new Btn($target.find('button[type="submit"]'));
    var $success = $target.find('[data-id="success"]');

    $target.find('form').on('submit', function(e) {
        var $self = $(this);
        // e.preventDefault();
        $success.addClass('d-none');
        if (this.checkValidity() === true) {
            $('.is-invalid', $self).removeClass('is-invalid');
            //$('button[type=submit]', $self).prop('disabled', true);

            $.ajax({
                type: 'post',
                dataType: 'json',
                data: $(this).serialize(),
                success: function(response) {
                    // console.log(response);
                    if (response.success && response.finished) {
                        $self.addClass('d-none');
                        $self[0].reset();
                        $self.removeClass('was-validated');

                        $success.removeClass('d-none');
                        var scrollPos = $success.offset().top;
                        window.scroller.animateScroll(Number(scrollPos) - Number($('header').outerHeight()));
                    } else if (response.errors) {
                        for (var key in response.errors) {
							//if (!response.errors.hasOwnProperty(key)) continue;
							if (!Object.prototype.hasOwnProperty.call(response.errors, key)) continue;
                            var messages = response.errors[key];

                            var $input = $('*[name=' + key + '], *[name="' + key + '[]"]');

                            $input.next('.invalid-feedback').html(messages.join(', '));
                            $input.addClass('is-invalid');
                        }
                    }

                    //$('button[type=submit]', $self).prop('disabled', false);
                    $btn.processed();
                }
            });

            return false;
        }
    });
};

export default func;